import React from "react";
import Card from "../../../../componets/Card";
import { WorldInterface } from "../../../../store/mods_factory/worldsSlice";

const _Details = ({ world }: { world: WorldInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Search text</h4>
        {world?.search_text}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Body Content</h4>
        {world?.body}
      </Card>
    </>
  );
}

export default _Details;
